import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<void, 'secondaryItem' | 'primaryItem'>()(
  ({ tokens }, _, classes) => ({
    formRoot: {
      width: '100%',
    },

    itemBox: {
      '&:last-child': {
        [`& .${classes.primaryItem}`]: {
          borderBottom: 0,
        },
      },
    },

    primaryItem: {
      border: `${tokens.border.s}px solid`,
      borderColor: tokens.colors.stroke.primary,
      borderLeft: 0,
      borderTop: 0,
      borderRight: 0,
    },

    secondaryItem: {
      padding: `${tokens.spacing['12']}px ${tokens.spacing['16']}px`,
      border: `${tokens.border.s}px solid`,
      borderColor: tokens.colors.stroke.primary,
      borderRadius: tokens.radius.m,
    },

    checkedItem: {
      borderColor: tokens.colors.original.brand.primary,
    },

    labelRoot: {
      margin: 0,
      width: '100%',
    },

    inputRoot: {
      paddingTop: 0,
      paddingRight: tokens.spacing['2'],
      paddingBottom: 0,
      paddingLeft: tokens.spacing['2'],
      marginRight: tokens.spacing['12'],

      '&:hover, &:hover.Mui-checked': {
        backgroundColor: 'transparent',
      },

      '& .MuiFormControlLabel-root': {
        marginLeft: 0,
        marginRight: 0,
      },

      '& .vkuiIcon path': {
        fill: tokens.colors.stroke.primary,
      },

      '&.Mui-checked .vkuiIcon path': {
        fill: tokens.colors.original.brand.primary,
      },
    },
  }),
);
